<template>
  <div
    v-if="active"
    class="tab-pane"
  >
    <!-- 二级tabs -->
    <div class="second-level">
      <slot name="secondLevel"></slot>
    </div>
    <slot/>
  </div>
</template>

<script>
  import {tabItemProps} from './index.js'

  export default {
    name: 'tab-item',
    props: tabItemProps,
    data () {
      return {}
    },
    watch: {
      label: {
        handler (val) {
          this.$parent.$emit('updateTabPaneLabel', this.name)
        }
      },
      count (val) {
        this.$parent.$emit('updateTabPaneLabel', this.name)
      }
    },
    computed: {
      active () {
        return this.$parent.currentName === this.name
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
